// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180704/js/" + chunkId + "." + {"44":"6a7f8be3","225":"12465d4e","481":"9888516c","486":"c97f5f3e","770":"65756613"}[chunkId] + ".0.8715146523482571.chunk.js";
};